import { classNameJoin } from 'utils/lib'

export const Step = ({ step }: { step: number }) => {
    return (
        <article className="flex flex-col items-center gap-2 w-[90%]">
            <div className="flex flex-row justify-between relative w-full">
                <div
                    className={classNameJoin([
                        'w-[8%] aspect-square rounded-full',
                        `${
                            step === 0
                                ? 'bg-[#f52388] text-[#FEFEFE]'
                                : 'bg-[#fefefe] text-[#B1B1B1] border border-[#B1B1B1] '
                        }`,
                        `flex items-center justify-center`,
                        `text-[clamp(14px,3vw,18px)] font-medium`,
                        'z-20',
                    ])}
                >
                    1
                </div>
                <div
                    className={classNameJoin([
                        'w-[8%] aspect-square rounded-full',
                        `${
                            step === 1
                                ? 'bg-[#f52388] text-[#FEFEFE]'
                                : 'bg-[#fefefe] text-[#B1B1B1] border border-[#B1B1B1] '
                        }`,
                        `flex items-center justify-center`,
                        `text-[clamp(14px,3vw,18px)] font-medium`,
                        'z-20',
                    ])}
                >
                    2
                </div>
                <div
                    className={classNameJoin([
                        'w-[8%] aspect-square rounded-full',
                        `${
                            step === 2
                                ? 'bg-[#f52388] text-[#FEFEFE]'
                                : 'bg-[#fefefe] text-[#B1B1B1] border border-[#B1B1B1] '
                        }`,
                        `flex items-center justify-center`,
                        `text-[clamp(14px,3vw,18px)] font-medium`,
                        'z-20',
                    ])}
                >
                    3
                </div>
                <div className="w-full h-[1px] bg-[#e2e2e2] absolute top-[50%] z-10" />
            </div>
            <div className="flex flex-row justify-between w-full">
                <p
                    className={classNameJoin([
                        'translate-x-[-25%]',
                        'text-[clamp(12px,3vw,16px)] font-medium',
                        `${step === 0 ? 'text-[#f52388]' : 'text-[#B1B1B1]'}`,
                    ])}
                >
                    사업자 정보
                </p>
                <p
                    className={classNameJoin([
                        'translate-x-[-10%]',
                        'text-[clamp(12px,3vw,16px)] font-medium',
                        `${step === 1 ? 'text-[#f52388]' : 'text-[#B1B1B1]'}`,
                    ])}
                >
                    셀러 정보
                </p>
                <p
                    className={classNameJoin([
                        'translate-x-[25%]',
                        'text-[clamp(12px,3vw,16px)] font-medium',
                        `${step === 2 ? 'text-[#f52388]' : 'text-[#B1B1B1]'}`,
                    ])}
                >
                    추가 정보
                </p>
            </div>
        </article>
    )
}
